import { useState, useEffect } from "react";
import "./style.css";
import api from "../../../services/api.js";
import Modal from "react-modal";
import PopUp from "../../../componente/popup/index.jsx";
import { useAppContext } from '../../../context/AppContext.js';

function CadOrcamento() {
  const { DateTime } = require("luxon");

  const [lista, setlista] = useState([]);
  const [abusca, setabusca] = useState("");
  const [showform, setshowform] = useState(false);

  const [edtcodorcamento, setedtcodorcamento] = useState(0);
  const [edtdescricao, setedtdescricao] = useState("");
  const [edtdtinicio, setedtdtinicio] = useState("");
  const [edtdtfim, setedtdtfim] = useState("");
  const [edtsaldoreais, setedtsaldoreais] = useState("");
  const [edtsaldocoinpremio, setedtsaldocoinpremio] = useState("");
  const [edtsaldocoinchecklist, setedtsaldocoinchecklist] = useState("");
  const [edtsaldocoinranking, setedtsaldocoinranking] = useState("");

  const [novo, setnovo] = useState(false);

  const [isOpen, setIsOpen] = useState(false);

  const { codassinante, selectedCompany, accessKey } = useAppContext();

  const handleOpen = (cad) => {
    setedtcodorcamento(cad.codorcamento);
    setIsOpen(true);
  };

  const handleConfirma = () => {
    setIsOpen(false);
    Excluir();
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  function ListarOrcamento() {

    api
      .get("/v1/cadastro/orcamento", {
        params: {
          busca: abusca,
          codassinante: codassinante,
          codempresa: selectedCompany
        },
        headers: {
          Authorization: `Bearer ${accessKey}`,
        },
      })
      .then(function (response) {
        setlista(response.data);
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  useEffect(
    function () {
      ListarOrcamento();
    },
    [showform, abusca, selectedCompany]
  );

  function Cadastrar() {
    api
      .post(
        "/v1/cadastro/orcamento",
        {
          descricao: edtdescricao,
          dtinicio: edtdtinicio,
          dtfim: edtdtfim,
          saldoreais: edtsaldoreais,
          saldocoinpremio: edtsaldocoinpremio,
          saldocoinchecklist: edtsaldocoinchecklist,
          saldocoinranking: edtsaldocoinranking,
          excluido: "N",
          codassinante,
          codempresa: selectedCompany
        },
        {
          headers: {
            Authorization: `Bearer ${accessKey}`,
          },
        }
      )
      .then(() => {
        ListarOrcamento();
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function Editar() {
    api
      .put(
        "v1/cadastro/orcamento",
        {
          codorcamento: edtcodorcamento,
          descricao: edtdescricao,
          dtinicio: edtdtinicio,
          dtfim: edtdtfim,
          saldoreais: edtsaldoreais,
          saldocoinpremio: edtsaldocoinpremio,
          saldocoinchecklist: edtsaldocoinchecklist,
          saldocoinranking: edtsaldocoinranking,
        },
        {
          headers: {
            Authorization: `Bearer ${accessKey}`,
          },
        }
      )
      .then(() => {
        ListarOrcamento();
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function Excluir() {
    api
      .delete("v1/cadastro/orcamento", {
        params: {
          codorcamento: edtcodorcamento,
        },
        headers: {
          Authorization: `Bearer ${accessKey}`,
        },
      })
      .then(() => {
        ListarOrcamento();
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function Salvar() {
    novo ? Cadastrar() : Editar();
    setshowform(false);
  }

  function closeModal() {
    setshowform(false);
  }

  function openModalNovo() {
    setshowform(true);
    setnovo(true);

    setedtcodorcamento(0);
    setedtdescricao("");

    const dt = new Date();
    const date =
      dt.getFullYear() +
      "-" +
      (dt.getMonth() + 1).toString().padStart(2, "0") +
      "-" +
      dt.getDate().toString().padStart(2, "0");    
    let dtcadastro = date;

    setedtdtinicio(dtcadastro);
    setedtdtfim(dtcadastro);
    setedtsaldoreais(0);
    setedtsaldocoinpremio(0);
    setedtsaldocoinchecklist(0);
    setedtsaldocoinranking(0);
  }

  function openModalEditar(cad) {
    setshowform(true);
    setnovo(false);

    setedtcodorcamento(cad.codorcamento);
    setedtdescricao(cad.descricao);

    const dt1 = DateTime.fromISO(cad.dtinicio)
      .plus({ hours: 3 })
      .toFormat("yyyy-MM-dd");

    setedtdtinicio(dt1);

    const dt2 = DateTime.fromISO(cad.dtfim)
      .plus({ hours: 3 })
      .toFormat("yyyy-MM-dd");

    setedtdtfim(dt2);
    setedtsaldoreais(cad.saldoreais);
    setedtsaldocoinpremio(cad.saldocoinpremio);
    setedtsaldocoinchecklist(cad.saldocoinchecklist);
    setedtsaldocoinranking(cad.saldocoinranking);
  }

  return (
    <>
      <div className="app-container">
        <div className="container-fluid">
          <div>
            <div>
              <PopUp isOpen={isOpen} onClose={handleClose}>
                <h2>Verificação</h2>
                <p>Tem certeza que deseja excluir esse registro?</p>

                <div className="row">
                  <div className="col-12 mt-3 d-flex justify-content-end">
                    <button
                      className="btn btn-primary me-2"
                      onClick={handleConfirma}
                    >
                      Sim
                    </button>
                    <button className="btn btn-danger" onClick={handleClose}>
                      Não
                    </button>
                  </div>
                </div>
              </PopUp>
            </div>

            <Modal
              isOpen={showform}
              onRequestClose={closeModal}
              overlayClassName="modal-overlay"
              className="modal-content"
            >
              <div className="container-fluid h-100">
                <div className="row">
                  <h2>Novo Cadastro</h2>
                </div>
                <div className="row">
                  <hr />
                </div>

                <form>
                  <div className="row">
                    <div className="col-sm-5">
                      <label htmlFor="descricao" className="form-label">
                        Descrição
                      </label>
                      <input
                        type="text"
                        id="descricao"
                        className="form-control"
                        placeholder="Descrição"
                        value={edtdescricao}
                        onChange={(e) => setedtdescricao(e.target.value)}
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-sm-3">
                      <label htmlFor="dtinicio" className="form-label">
                        Dt. Início
                      </label>
                      <input
                        type="date"
                        id="dtinicio"
                        className="form-control"
                        placeholder="Dt. Início"
                        value={edtdtinicio}
                        onChange={(e) => setedtdtinicio(e.target.value)}
                      />
                    </div>

                    <div className="col-sm-3">
                      <label htmlFor="dtfim" className="form-label">
                        Dt. Fim
                      </label>
                      <input
                        type="date"
                        id="dtfim"
                        className="form-control"
                        placeholder="Dt. Fim"
                        value={edtdtfim}
                        onChange={(e) => setedtdtfim(e.target.value)}
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-sm-3">
                      <label htmlFor="saldoreais" className="form-label">
                        Saldo Reais
                      </label>
                      <input
                        type="number"
                        id="saldoreais"
                        className="form-control"
                        placeholder="Saldo Reais"
                        value={edtsaldoreais}
                        onChange={(e) => setedtsaldoreais(e.target.value)}
                      />
                    </div>

                    <div className="col-sm-3">
                      <label htmlFor="saldocoinpremio" className="form-label">
                        Saldo Coin Prêmio
                      </label>
                      <input
                        type="number"
                        id="saldocoinpremio"
                        className="form-control"
                        placeholder="Saldo Coin Prêmio"
                        value={edtsaldocoinpremio}
                        onChange={(e) => setedtsaldocoinpremio(e.target.value)}
                      />
                    </div>

                    <div className="col-sm-3">
                      <label htmlFor="saldocoinchecklist" className="form-label">
                        Saldo Coin Checklist
                      </label>
                      <input
                        type="number"
                        id="saldocoinchecklist"
                        className="form-control"
                        placeholder="Saldo Coin Checklist"
                        value={edtsaldocoinchecklist}
                        onChange={(e) => setedtsaldocoinchecklist(e.target.value)}
                      />
                    </div>

                    <div className="col-sm-3">
                      <label htmlFor="saldocoinranking" className="form-label">
                        Saldo Coin Ranking
                      </label>
                      <input
                        type="number"
                        id="saldocoinranking"
                        className="form-control"
                        placeholder="Saldo Coin Ranking"
                        value={edtsaldocoinranking}
                        onChange={(e) => setedtsaldocoinranking(e.target.value)}
                      />
                    </div>
                  </div>
                </form>

                <div className="row">
                  <div className="col-12 mt-3 d-flex justify-content-end">
                    <button className="btn btn-danger ms-4" onClick={closeModal}>
                      Cancelar
                    </button>
                    <button className="btn btn-success ms-4" onClick={Salvar}>
                      Salvar
                    </button>
                  </div>
                </div>
              </div>
            </Modal>
          </div>

          <div className="row">
            <h1 className="ms-4">Cadastro de Orçamento</h1>
            <p className="ms-4">Rotina para cadastrar os orçamentos que serão disponibilizado para uso na empresa</p>
            <hr />
          </div>

          <div className="row">
            <div className="col-10">
              <label className="d-block" htmlFor="busca">
                Busque aqui
              </label>
              <input
                type="text"
                placeholder="Buscar por: Código ou descrição"
                name="busca"
                id="busca"
                className="form-control me-3"
                value={abusca}
                onChange={(e) => setabusca(e.target.value)}
              />
            </div>
            <div className="col-2 d-flex justify-content-center">
              <button
                className="btn btn-success btnnovo"
                onClick={() => openModalNovo()}
              >
                Novo
              </button>
            </div>
          </div>

          <div className="row mt-3">
            <hr />
          </div>

          <div className="row">
            <table className="table table-hover">
              <thead>
                <tr>
                  <th>Código</th>
                  <th>Período</th>
                  <th>Descrição</th>
                  <th>Saldo Reais</th>
                  <th>Saldo Coin Prêmio</th>
                  <th>Saldo Coin Checklist</th>
                  <th>Saldo Coin Ranking</th>
                  <th className="acao">Ações</th>
                </tr>
              </thead>
              <tbody>
                {lista.map(function (item) {
                  return (
                    <tr key={item.codorcamento}>
                      <th>{item.codorcamento}</th>
                      <th>{item.periodo}</th>
                      <th>{item.descricao}</th>
                      <th>{item.saldoreais1}</th>
                      <th>{item.saldocoin1}</th>
                      <th>{item.saldocoin2}</th>
                      <th>{item.saldocoin3}</th>
                      <th>
                        <div className="d-flex justify-content-center">
                          <button
                            className="btn fa-regular fa-pen-to-square"
                            onClick={() => openModalEditar(item)}
                          ></button>
                          <button
                            className="btn fa-solid fa-trash"
                            onClick={() => handleOpen(item)}
                          ></button>
                        </div>
                      </th>
                    </tr>
                  );
                })}
              </tbody>
              <tfoot>
                <tr>
                  <th colSpan={6}>Quantidade de Registros: {lista.length}</th>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
    </>
  );
}

export default CadOrcamento;
